import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import $ from './bootstrap';
import 'bootstrap';
import './listingMap';
import 'jquery-colorbox';
import 'owl.carousel';

const jQuery = $;

var locationZipFilter = null,
    searchFormFilter = null;


(function ($) {
    $(document).ready(function () {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });


        



        if ($('#notification_content').length > 0 && $('#notification_content').find('.notification').length > 0) {
            $.each($('#notification_content').find('.notification'), function (i, k) {
                $.hide_notification($(k));
            })
        }

        // if($('header#landing').length > 0 && $('#rotated-background').length > 0 && $('#landing-header').length > 0){

        //         var initSidebarObserver = new IntersectionObserver(function(entries) {

        //         // no intersection with screen
        //         if(entries[0].intersectionRatio === 0){
        //            $("#landing-header").addClass("scrolled").animate({'top': '0px'}, 400);
        //         }
        //         // fully intersects with screen
        //         else if(entries[0].intersectionRatio > 0){
        //            $("#landing-header").removeClass("scrolled").removeAttr('style');
        //         }

        //        }, { threshold: [0,1] });

        //        initSidebarObserver.observe(document.querySelector('#rotated-background'),document.querySelector('#landing-header'));

        // }


        if ($('#searchDropdown').length > 0) {
            $('#searchDropdown').on('click', function (e) {

                $('#searchDropdownMenuHolder').addClass('show');
                $('#searchDropdownMenu').addClass('show');
                $('.fullBodyOverlay').addClass('showed');
                return false;
            })
        }

        if ($('#searchDropdownInline').length > 0) {
            $('#searchDropdownInline').on('click', function (e) {

                $('#searchDropdownMenuHolder').addClass('show');
                $('#searchDropdownMenu').addClass('show');
                $('.fullBodyOverlay').addClass('showed');
                return false;
            })
        }


        if ($('#pills-tabContent').length > 0) {
            $('#pills-tabContent a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                $(e.target).attr('aria-selected', 'false').removeClass('active');
            })
        }
        if ($('#pills-tabContent-mobile').length > 0) {
            $('#pills-tabContent-mobile a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                $(e.target).attr('aria-selected', 'false').removeClass('active');
                $(e.target).closest('.header-only-mobile').addClass('show');
                $(e.target).closest('.header-only-mobile').find('.dropdown-menu').addClass('show');
                $('.fullBodyOverlay').addClass('showed')
            })
        }

        if ($('#selected-school').length > 0) {
            // $(this).scrollTop(0);
            // window.onbeforeunload = function () {
            //   window.scrollTo(0, 0);
            // };
            $(window).bind('popstate', function () {
                window.location.href = window.location.href;
            });
        }

        $('.tooltip-bt').tooltip({boundary: 'window'});
        // Global Close Event
        $(document).on('click', function (e) {
            var locationFilter = $("#bunner-search-school");
            if (!locationFilter.is(e.target) && locationFilter.has(e.target).length === 0) {
                $('#location-zip-content').empty();
            }

            var searchForm = $("#searchDropdownMenuHolder");
            if (!locationFilter.is(e.target) && locationFilter.has(e.target).length === 0) {
                $('#searchDropdownMenuHolder').removeClass('show').trigger('hide.bs.dropdown');
                $('#searchDropdownMenu').removeClass('show').trigger('hide.bs.dropdown');

            }

            var sitemapFilter = $("#searchDropdownResults");
            if (!locationFilter.is(e.target) && locationFilter.has(e.target).length === 0) {
                $('#searchDropdownResults').empty();
            }


        });


        if ($('#lw-widget-holder').length > 0) {
            $.showPopUpWidget();
        }


        if ($('#seo-help').length > 0) {

            $('#seo-help #links').on('click', 'a.nav-link', function (e) {
                e.preventDefault();
                // First Hide all other tabs and remove link class
                $('#seo-help').find('.tab-pane').removeClass('show').removeClass('active');
                $('#seo-help').find('#links a.nav-link').removeClass('active');

                var idShow = $(this).attr('href').replace("#", "");

                $('#seo-help').find('div[id^="' + idShow + '"]').tab('show');
                $(this).addClass('active');

                return false;
            })


        }


        if ($('#collapse-btn').length > 0) {


            $('#collapse-btn').on('click', 'a.view-more', function (e) {
                if ($(this).hasClass('view-more')) {
                    e.preventDefault();
                    $('#list-options').toggleClass('open');
                    $(this).text('Search Schools').removeClass('view-more');
                    return false;
                }
            });

        }


        if ($('#sugested-school-slider').length > 0) {

            var suggestwinWidth = $(window).width();
            var suggestcontainerWidth = $('#sugested-school-slider').closest('.container').width();
            var suggestrightSide = parseInt((suggestwinWidth - suggestcontainerWidth) / 2);
            var suggestflexedWidth = parseInt(suggestcontainerWidth + suggestrightSide + 160);
            var suggestcaroChangeTimeout = null;

            if ($(window).width() > 991)
                $('#sugested-school-slider-wrapper').css({'width': suggestflexedWidth + 'px'})


            setTimeout(function () {
                var topSuggested = $('#sugested-school-slider').owlCarousel({
                    loop: true,
                    margin: 15,
                    responsiveClass: true,
                    dots: false,
                    navText: ['<i class="fas fa-arrow-left"></i>', '<i class="fas fa-arrow-right"></i>'],
                    autoplay: true,
                    autoplayHoverPause: true,
                    autoplayTimeout: 8000,
                    responsive: {
                        0: {
                            items: 1,
                            nav: true
                        },
                        600: {
                            items: 2,
                            nav: true
                        },
                        991: {
                            items: 4,
                            nav: true,
                            loop: true
                        },
                        1199: {
                            items: 5,
                            nav: false,
                            loop: true
                        },
                        1639: {
                            items: 6,
                            nav: false,
                            loop: true
                        }
                    },
                    onInitialize: function (event) {
                        $('#sugested-school-slider').find('.owl-item').fadeTo(10, 1);

                        clearTimeout(suggestcaroChangeTimeout);

                        suggestcaroChangeTimeout = setTimeout(function () {
                            var active = $('#sugested-school-slider').find('.owl-item.active');
                            var lastEl = active[active.length - 1];

                            if ($(window).width() > 991)
                                $(lastEl).fadeTo(200, 0.4);

                            var schoolWrapperWidth = $('#sugested-school-slider').closest('.container').width();
                            $('#sugested-school-slider').find('.owl-dots').css({'width': schoolWrapperWidth + 'px'});

                        }, 100);


                    },
                    onChanged: function (event) {
                        $('#sugested-school-slider').find('.owl-item').fadeTo(10, 1);

                        clearTimeout(suggestcaroChangeTimeout);

                        suggestcaroChangeTimeout = setTimeout(function () {
                            var active = $('#sugested-school-slider').find('.owl-item.active');
                            var lastEl = active[active.length - 1];

                            if ($(window).width() > 991)
                                $(lastEl).fadeTo(200, 0.4);

                        }, 100);

                    },
                    onDragged: function (event) {
                        $('#sugested-school-slider').find('.owl-item').fadeTo(10, 1);

                        clearTimeout(suggestcaroChangeTimeout);

                        suggestcaroChangeTimeout = setTimeout(function () {
                            var active = $('#sugested-school-slider').find('.owl-item.active');
                            var lastEl = active[active.length - 1];

                            if ($(window).width() > 991)
                                $(lastEl).fadeTo(200, 0.4);

                        }, 100);

                    },
                    onRefresh: function (event) {
                        $('#sugested-school-slider').find('.owl-item').fadeTo(10, 1);
                        clearTimeout(suggestcaroChangeTimeout);

                        suggestcaroChangeTimeout = setTimeout(function () {
                            var active = $('#sugested-school-slider').find('.owl-item.active');
                            var lastEl = active[active.length - 1];

                            if ($(window).width() > 991)
                                $(lastEl).fadeTo(200, 0.4);

                            var schoolWrapperWidth = $('#sugested-school-slider').closest('.container').width();
                            $('#sugested-school-slider').find('.owl-dots').css({'width': schoolWrapperWidth + 'px'});

                        }, 100);

                    }
                });


                $(window).resize(function () {
                    clearTimeout(window.resizedFinished);
                    window.resizedFinished = setTimeout(function () {
                        var suggestwinWidth = $(window).width();
                        var suggestcontainerWidth = $('#sugested-school-slider').closest('.container').width();
                        var suggestrightSide = parseInt((suggestwinWidth - suggestcontainerWidth) / 2);
                        var suggestflexedWidth = parseInt(suggestcontainerWidth + suggestrightSide + 160);
                        var suggestcaroChangeTimeout = null;

                        if ($(window).width() > 991)
                            $('#sugested-school-slider-wrapper').css({'width': suggestflexedWidth + 'px'})
                        else
                            $('#sugested-school-slider-wrapper').css({'width': '100%'})

                        topSuggested.trigger('refresh.owl.carousel');

                    }, 400);
                });

            }, 400);

        }


        if ($('#slider-on-mobile-homepage').length > 0) {

            var winWidth = $(window).width();
            var containerWidth = $('#schools-wraper').width();
            var rightSide = parseInt((winWidth - containerWidth) / 2);
            var flexedWidth = parseInt(containerWidth + rightSide + 160);
            var caroChangeTimeout = null;

            if ($(window).width() > 991)
                $('#flexed').css({'width': flexedWidth + 'px'})


            setTimeout(function () {
                var topRated = $('#slider-on-mobile-homepage').owlCarousel({
                    loop: true,
                    margin: 15,
                    responsiveClass: true,
                    dots: true,
                    nav: true,
                    navText: ['<i class="fas fa-arrow-left"></i>', '<i class="fas fa-arrow-right"></i>'],
                    autoplay: true,
                    autoplayHoverPause: true,
                    autoplayTimeout: 8000,
                    responsive: {
                        0: {
                            items: 1,
                            nav: false
                        },
                        600: {
                            items: 2,
                            nav: false
                        },
                        991: {
                            items: 3,
                            nav: false,
                            loop: true
                        },
                        1199: {
                            items: 4,
                            nav: false,
                            loop: true
                        },
                        1639: {
                            items: 5,
                            nav: false,
                            loop: true
                        }
                    },
                    onInitialized: function (event) {

                        var pageIndexPercentage = parseFloat(100 / event.item.count).toFixed(2);
                        var firstIndex = parseInt(event.item.index - 1);
                        var lastIndex = parseInt(firstIndex + event.item.count);
                        var multyPercent = 0;
                        this['firstIndex'] = firstIndex;
                        this['indexedArray'] = {};
                        for (firstIndex; firstIndex <= lastIndex; firstIndex++) {
                            this.indexedArray[firstIndex] = parseFloat(multyPercent * pageIndexPercentage).toFixed(2);
                            multyPercent++;
                        }

                        var owlSlide = $('#schools-scroller').find('.progress-bar');
                        $(owlSlide).css({'width': pageIndexPercentage + '%'});

                        // return this;
                    },
                    onInitialize: function (event) {
                        $('#slider-on-mobile-homepage').find('.owl-item').fadeTo(10, 1);

                        clearTimeout(caroChangeTimeout);

                        caroChangeTimeout = setTimeout(function () {
                            var active = $('#slider-on-mobile-homepage').find('.owl-item.active');
                            var lastEl = active[active.length - 1];

                            if ($(window).width() > 991)
                                $(lastEl).fadeTo(200, 0.4);

                            var owlSlide = $('#slider-on-mobile-homepage').find('.owl-slide');

                            var schoolWrapperWidth = $('#schools-wraper').width() - 88;
                            $('#slider-on-mobile-homepage').find('.owl-dots').css({'width': schoolWrapperWidth + 'px'});
                            $('#slider-on-mobile-homepage').find('.owl-nav').css({'width': schoolWrapperWidth + 'px'});

                        }, 100);

                    },
                    onDragged: function (event) {
                        $('#slider-on-mobile-homepage').find('.owl-item').fadeTo(10, 1);

                        clearTimeout(caroChangeTimeout);

                        caroChangeTimeout = setTimeout(function () {
                            var active = $('#slider-on-mobile-homepage').find('.owl-item.active');
                            var lastEl = active[active.length - 1];

                            if ($(window).width() > 991)
                                $(lastEl).fadeTo(200, 0.4);

                        }, 100);

                    },
                    onChanged: function (event) {

                        $('#slider-on-mobile-homepage').find('.owl-item').fadeTo(10, 1);

                        clearTimeout(caroChangeTimeout);


                        caroChangeTimeout = setTimeout(function () {
                            if ($('#slider-on-mobile-homepage').find('.owl-slide').length > 0) {

                            } else {
                                var owlSlideDiv = '<div class="owl-slide"></div>';
                                $(owlSlideDiv).appendTo($('#slider-on-mobile-homepage').find('.owl-dots'));
                            }

                            var active = $('#slider-on-mobile-homepage').find('.owl-item.active');
                            var lastEl = active[active.length - 1];

                            if ($(window).width() > 991)
                                $(lastEl).fadeTo(200, 0.4);

                            var schoolWrapperWidth = $('#schools-wraper').width() - 88;
                            $('#slider-on-mobile-homepage').find('.owl-dots').css({'width': schoolWrapperWidth + 'px'});
                            $('#slider-on-mobile-homepage').find('.owl-nav').css({'width': schoolWrapperWidth + 'px'});


                        }, 100);


                        var owlSlide = $('#schools-scroller').find('.progress-bar');
                        var currentIndex = event.item.index;
                        if (currentIndex) {
                            var percentageFill = this.indexedArray[currentIndex];
                        }


                        if (percentageFill)
                            $(owlSlide).css({'width': percentageFill + '%'});


                    },
                    onRefresh: function (event) {
                        $('#slider-on-mobile-homepage').find('.owl-item').fadeTo(10, 1);
                        clearTimeout(caroChangeTimeout);

                        caroChangeTimeout = setTimeout(function () {

                            if ($('#slider-on-mobile-homepage').find('.owl-slide').length > 0) {

                            } else {
                                var owlSlideDiv = '<div class="owl-slide"></div>';
                                $(owlSlideDiv).appendTo($('#slider-on-mobile-homepage').find('.owl-dots'));
                            }

                            var active = $('#slider-on-mobile-homepage').find('.owl-item.active');
                            var lastEl = active[active.length - 1];

                            if ($(window).width() > 991)
                                $(lastEl).fadeTo(200, 0.4);


                            var schoolWrapperWidth = $('#schools-wraper').width() - 88;
                            $('#slider-on-mobile-homepage').find('.owl-dots').css({'width': schoolWrapperWidth + 'px'});
                            $('#slider-on-mobile-homepage').find('.owl-nav').css({'width': schoolWrapperWidth + 'px'});

                        }, 100);

                    }
                });


                $(window).resize(function () {
                    clearTimeout(window.resizedFinished);
                    window.resizedFinished = setTimeout(function () {
                        var winWidth = $(window).width();
                        var containerWidth = $('#schools-wraper').width();
                        var rightSide = parseInt((winWidth - containerWidth) / 2);
                        var flexedWidth = parseInt(containerWidth + rightSide + 160);
                        var caroChangeTimeout = null;

                        if ($(window).width() > 991)
                            $('#flexed').css({'width': flexedWidth + 'px'})
                        else
                            $('#flexed').css({'width': '100%'})

                        topRated.trigger('refresh.owl.carousel');

                    }, 400);
                });

            }, 400);

        }


        if ($('#slider-on-reviews-homepage').length > 0) {

            var reWwinWidth = $(window).width();
            var reWcontainerWidth = $('#no-wrap').closest('.container').width();
            var reWholderWidth = $('#no-wrap').closest('.col-lg-6').width();
            var reWrightSide = parseInt((reWwinWidth - reWcontainerWidth) / 2);
            var reWflexedWidth = parseInt(reWholderWidth + reWrightSide + 165);
            var reWcaroChangeTimeout = null;

            if ($(window).width() > 991)
                $('#no-wrap').css({'width': reWflexedWidth + 'px'})


            setTimeout(function () {
                var topReviews = $('#slider-on-reviews-homepage').owlCarousel({
                    loop: true,
                    margin: 25,
                    nav: true,
                    navText: ['<i class="fas fa-arrow-left"></i>', '<i class="fas fa-arrow-right"></i>'],
                    responsiveClass: true,
                    dots: false,
                    autoplay: false,
                    autoplayHoverPause: true,
                    autoplayTimeout: 8000,
                    responsive: {
                        0: {
                            items: 1,
                            nav: true
                        },
                        600: {
                            items: 1,
                            nav: true
                        },
                        991: {
                            items: 2,
                            nav: true,
                            loop: true
                        },
                        1199: {
                            items: 2,
                            nav: true,
                            loop: true
                        },
                        1639: {
                            items: 2,
                            nav: true,
                            loop: true
                        }
                    },
                    onInitialize: function (event) {
                        $('#slider-on-reviews-homepage').find('.owl-item').fadeTo(10, 1);

                        clearTimeout(reWcaroChangeTimeout);

                        reWcaroChangeTimeout = setTimeout(function () {
                            var active = $('#slider-on-reviews-homepage').find('.owl-item.active');
                            var lastEl = active[active.length - 1];

                            if ($(window).width() > 991)
                                $(lastEl).fadeTo(200, 0.4);

                            var colWrapperWidth = $('#no-wrap').closest('.col-lg-6').width();
                            $('#slider-on-reviews-homepage').find('.owl-nav').css({'width': colWrapperWidth + 'px'});


                        }, 100);

                        var pageShow = '<div id="slideCounter" class="counter"><span class="active active-review"></span><span class="middle-line">/</span><span class="notactive-review"></span></div>';
                        $('#no-wrap').append(pageShow);


                    },
                    // onDragged: function(event){
                    //     $('#slider-on-reviews-homepage').find('.owl-item').fadeTo(10,1);

                    //     clearTimeout(reWcaroChangeTimeout);

                    //     reWcaroChangeTimeout = setTimeout(function () {
                    //       var active = $('#slider-on-reviews-homepage').find('.owl-item.active');
                    //       var lastEl = active[active.length-1];

                    //       if($(window).width() > 991)
                    //         $(lastEl).fadeTo(200, 0.4);

                    //       var changeNumbers = $('#no-wrap').find('#slideCounter');
                    //       var indexCalculated = parseInt((event.item.index%event.item.count)+1);
                    //           $(changeNumbers).find('span.active-review').text(indexCalculated);
                    //           $(changeNumbers).find('span.notactive-review').text(event.item.count);

                    //     }, 100);
                    // },
                    onChange: function (event) {

                        $('#slider-on-reviews-homepage').find('.owl-item').fadeTo(10, 1);

                        clearTimeout(reWcaroChangeTimeout);

                        reWcaroChangeTimeout = setTimeout(function () {
                            var active = $('#slider-on-reviews-homepage').find('.owl-item.active');
                            var lastEl = active[active.length - 1];

                            if ($(window).width() > 991)
                                $(lastEl).fadeTo(200, 0.4);

                            var colWrapperWidth = $('#no-wrap').closest('.col-lg-6').width();
                            $('#slider-on-reviews-homepage').find('.owl-nav').css({'width': colWrapperWidth + 'px'});

                            var changeNumbers = $('#no-wrap').find('#slideCounter');
                            var indexCalculated = parseInt((event.item.index % event.item.count) + 1);
                            $(changeNumbers).find('span.active-review').text(indexCalculated);
                            $(changeNumbers).find('span.notactive-review').text(event.item.count);

                        }, 100);


                    },
                    onRefresh: function (event) {
                        $('#slider-on-reviews-homepage').find('.owl-item').fadeTo(10, 1);
                        clearTimeout(reWcaroChangeTimeout);

                        reWcaroChangeTimeout = setTimeout(function () {
                            var active = $('#slider-on-reviews-homepage').find('.owl-item.active');
                            var lastEl = active[active.length - 1];

                            if ($(window).width() > 991)
                                $(lastEl).fadeTo(200, 0.4);


                            var colWrapperWidth = $('#no-wrap').closest('.col-lg-6').width();
                            $('#slider-on-reviews-homepage').find('.owl-nav').css({'width': colWrapperWidth + 'px'});

                            var changeNumbers = $('#no-wrap').find('#slideCounter');
                            var indexCalculated = parseInt((event.item.index % event.item.count) + 1);
                            $(changeNumbers).find('span.active-review').text(indexCalculated);
                            $(changeNumbers).find('span.notactive-review').text(event.item.count);


                        }, 100);


                    }
                });


                $(window).resize(function () {
                    clearTimeout(window.resizedFinished);
                    window.resizedFinished = setTimeout(function () {
                        var reWwinWidth = $(window).width();
                        var reWcontainerWidth = $('#no-wrap').closest('.container').width();
                        var reWholderWidth = $('#no-wrap').closest('.col-lg-6').width();
                        var reWrightSide = parseInt((winWidth - containerWidth) / 2);
                        var reWflexedWidth = parseInt(reWholderWidth + rightSide + 225);
                        var reWcaroChangeTimeout = null;

                        if ($(window).width() > 991)
                            $('#no-wrap').css({'width': reWflexedWidth + 'px'})
                        else
                            $('#no-wrap').css({'width': '100%'})

                        topReviews.trigger('refresh.owl.carousel');

                    }, 400);
                });


            }, 400);

        }


        if ($('.all-photos').length > 0) {

            $.initColorBox('.schoolSlider', 'schoolSlider');
        }

        $('.dropdownBgShow').on('show.bs.dropdown', function () {
            $('.fullBodyOverlay').addClass('showed')
        }).on('hide.bs.dropdown', function () {
            $('.fullBodyOverlay').removeClass('showed')
        })


        if ($('#review-form').length > 0) {
            $.initReviewForm();
        }

        if ($('#selected-school').length > 0) {
            $.smoothScroll();
            $.initLoadEmailsSchool();
            // $.initProgramsSchool();
            // $.initLocationListSchool();
            $.initNavigateClick();
            $.programReadMoreClick();
        }


        $(document).on("keydown", "form#bunner-search-school", function(event) { 
            if(event.keyCode === 13){
                event.preventDefault();
                if($('form#bunner-search-school').find('#location-zip-content a.zipListItem').length > 0){
                    $('form#bunner-search-school').find('#location-zip-content a.zipListItem').first().trigger('click');
                    $('form#bunner-search-school').find('#submit-search input').trigger('focus');

                    return false;
                }else{
                    return false;

                }
            }
        });


        $('#search-location').on('keyup', 'input#location-zip-filter', function (e) {
            e.preventDefault();
            
            var value = $(this).val();
            if (value) {

                if (Number.isInteger(value) && value.length < 4) {
                    return;
                }

                if (value.length < 3) {
                    $('#location-zip-content').empty();

                    return;
                }


                clearTimeout(locationZipFilter);


                locationZipFilter = setTimeout(function () {
                    $.filter_zipLocation_search(value, '#location-zip-content');

                }, 200);
                
            }

        }).on('focus', 'input#location-zip-filter', function (e) {
            e.preventDefault();

            var value = $(this).val();
            if (value) {
                if (value.length > 2) {
                    clearTimeout(locationZipFilter);
                    locationZipFilter = setTimeout(function () {
                        $.filter_zipLocation_search(value, '#location-zip-content')
                    }, 200);

                }
            }

        }).on('focusout', 'input#location-zip-filter', function (e) {
            e.preventDefault();

            var value = $(this).val();
            if (value) {
                if (value.length > 2) {
                    clearTimeout(locationZipFilter);
                    locationZipFilter = setTimeout(function () {
                        $.removeOverlay('#location-zip-content');
                        // $.filter_zipLocation_search(value,'#location-zip-content')
                    }, 400);

                }
            }

        });


        $('#searchDropdownMenuHolder').on('keyup', 'input#search-input', function (e) {
            // e.preventDefault();
            var value = $(this).val();
            if (value) {
                clearTimeout(searchFormFilter);
                searchFormFilter = setTimeout(function () {
                    $.filter_sitemap_search(value, '#searchDropdownResults');

                }, 600);
            }

        });


        $('#search-location').on('click', 'a.zipListItem', function () {

            var value = $(this).data('zip');
            var name = $(this).data('city');
            var lat = $(this).data('lat');
            var lng = $(this).data('lng');
            var locationText = $(this).data('text');
            if (value && name) {

                var inputSearchedText = $('#search-location').find('#location-zip-filter').val();

                // var encodedSearch = inputSearchedText+' ['+locationText+']';
                // gtag("event", "search", {
                //   search_term: encodedSearch
                // });


                var encodedSearch = encodeURI(inputSearchedText + ' [' + locationText + ']');
                gtag("event", "page_view", {
                    page_location: "https://www.driving-schools.com/search?q=" + encodedSearch,
                    page_path: "/search?q=" + encodedSearch,
                    page_title: "Search By Location"
                });

                $('#search-location').find('input#location-zip-filter-hidden').val(value);
                $('#search-location').find('input#location-zip-lng-hidden').val(lng);
                $('#search-location').find('input#location-zip-lat-hidden').val(lat);
                $('#search-location').find('input#location-zip-city-hidden').val(name);
                $('#search-location').find('input#location-zip-filter').val(locationText);
                $('#location-zip-content').empty();
            }

        });


    });
})(jQuery);


$.fn.schoolPageMap = function (options) {

    var defaults = {
        url: '/find-schools',
        defaultUrl: '/',
        selectedLocation: {},
        locations: {},
        lat: 29.92363800,
        lng: -95.55919000,
        mapWrapper: 'school-map-fixed',
        styledMapType: false
    };

    this.settings = $.extend({}, defaults, options);
    if (this.length > 1) {
        this.each(function () {
            $(this).pluginName(options)
        });
        return this;
    }
    if (typeof styledMapType === 'undefined' || !styledMapType)
        var styledMapType = $.getStyledGoogleMap();

    this.settings.styledMapType = styledMapType;

    var pagedData, geocoder, map, mapLoaded = false, markers = [], infoWindows = [], serviceAreas = [];
    var iconimage = new google.maps.MarkerImage(this.settings.defaultUrl + '/img/svg/map-pointer.svg', null, null, null, new google.maps.Size(36, 42));
    var iconimageHover = new google.maps.MarkerImage(this.settings.defaultUrl + '/img/svg/map-pointer-hover.svg', null, null, null, new google.maps.Size(36, 42));

    this.initialize = function () {
        // do something ...
        this.loadMap();
        return this;
    };
    this.loadMap = function () {

        var that = this;
        geocoder = new google.maps.Geocoder();

        map = new google.maps.Map(document.getElementById(this.settings.mapWrapper), {
            zoom: 9,
            center: {
                lat: parseFloat(that.settings.selectedLocation.latitude),
                lng: parseFloat(that.settings.selectedLocation.longitude)
            },
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeControl: false,
            mapTypeControlOptions: {
                mapTypeIds: ['styled_map']
            }
        });

        mapLoaded = true;
        // map.setCenter(results[0].geometry.location);
        map.mapTypes.set('styled_map', this.settings.styledMapType);
        map.setMapTypeId('styled_map');

        that.placeMarkers();

    };
    this.jSwitchCall = function () {

        $('.tooltip-bt').tooltip({boundary: 'window'});
    }
    this.closeInfoWindows = function () {
        for (var i = 0; i < infoWindows.length; i++) {
            infoWindows[i].close();
        }

        return true;
    };
    this.closeServiceAreas = function () {
        map.data.forEach(function (feature) {
            if (serviceAreas.includes(feature.getProperty("Id"))) {
                map.data.remove(feature)
            }
        });
        serviceAreas = [];
        return true;
    };

    this.displayServiceArea = function (location) {
        if (location.service_areas) {
            map.data.setStyle({
                strokeColor: '#E63946',
                strokeOpacity: 0.8,
                strokeWeight: 1,
                fillColor: '#E63946',
                fillOpacity: 0.2
            });
            $.each(location.service_areas, function (i, k) {
                if (k) {
                    map.data.addGeoJson(
                        k.json_shape
                    );
                    serviceAreas.push(k.id);
                }

            });
        }
    };

    this.placeMarkers = function () {
        var that = this;

        if (that.settings.locations.length > 0) {
            $.each(that.settings.locations, function (i, k) {
                that.addMarker({lat: parseFloat(k.latitude), lng: parseFloat(k.longitude)}, k);
            });
        }
    };
    this.infoWindowString = function (location) {


        if (location.image) {
            var image = this.settings.defaultUrl + '/' + location.image;
            var explodeFilename = location.image.split('.');
            if (typeof explodeFilename[0] !== 'undefined')
                var imageFileName = this.settings.defaultUrl + '/' + explodeFilename[0] + '.webp';

        } else if (location.schoolImage) {
            var image = this.settings.defaultUrl + '/uploads/images/schools/' + location.schoolImage;
            var explodeFilename = location.schoolImage.split('.');
            if (typeof explodeFilename[0] !== 'undefined')
                var imageFileName = this.settings.defaultUrl + '/uploads/images/schools/' + explodeFilename[0] + '.webp';

        } else {
            var image = this.settings.defaultUrl + '/img/noimage.jpg';
            var imageFileName = this.settings.defaultUrl + '/img/noimage.webp';
        }


        var locationLink = '/school/' + location.schoolSlug + '/location/' + location.id,
            loaderIcon = this.settings.defaultUrl + '/img/loader.svg',
            avg = (!location.reviewsAVG) ? '4.8' : parseFloat(location.reviewsAVG);


        var contentString = '<div class="info-window-content">' +
            '<div class="info-window-box">' +
            '<div class="info-window-text">' +
            '<div class="image-view">' +
            '<div class="info-window-image-holder">';
        contentString += '        <picture>';
        if (imageFileName) {
            contentString += '        <source srcset="' + imageFileName + '" type="image/webp">';
        }
        contentString += '        <img class="lazyload info-window-image" alt="' + location.name + '" data-src="' + image + '" loading="lazy" width="80" height="45">';
        contentString += '        </picture>' +
            '</div>' +
            '<div class="info-window-name">' +
            '<label class="location-label"><i class="fas fa-map-marker-alt"></i>' + location.displayAddress + '</label>' +
            '</div>' +
            '</div>' +
            '<div class="contact-view">' +
            '<div class="info-window-flex">';
        if (location.phoneOne) {
            contentString += '<div class="contact-block">' +
                '<label>Contact Phone</label>' +
                '<a href="tel:' + location.phoneOne.replace(/[^0-9]/g, "") + '">' +
                '<i class="fas fa-phone-alt"></i>' + location.phoneOne +
                '</a>' +
                '</div>';
        }
        if (location.longitude && location.latitude) {
            contentString += '<div class="contact-block">' +
                '<label>Direction</label>' +
                '<a href="http://maps.google.com?daddr=' + location.latitude + ',' + location.longitude + '&amp;ll=" class="getDirectionClick" data-lat="' + location.latitude + '" data-lng="' + location.longitude + '">' +
                '<i class="fas fa-street-view"></i> Get Directions' +
                '</a>' +
                '</div>';
        }
        contentString += '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';


        return contentString;

    }
    this.addMarker = function (position, location) {
        if (!markers[location.id]) {
            var that = this;

            var contentString = that.infoWindowString(location);

            var marker = new google.maps.Marker({
                position: position,
                label: '',
                // icon: (that.settings.selectedLocation.id && that.settings.selectedLocation.id == location.id) ? iconimageHover : iconimage,
                icon: iconimage,
                draggable: false,
                map: map,
                animation: google.maps.Animation.DROP,
            });


            var infowindow = new google.maps.InfoWindow({
                content: contentString,
                maxWidth: 420
            });

            infoWindows.push(infowindow);

            // if(that.settings.selectedLocation.id && that.settings.selectedLocation.id == location.id){
            //     that.displayServiceArea(location);
            // }

            marker.addListener('click', function () {
                marker.setIcon(iconimageHover);
                $.when(that.closeInfoWindows(), that.closeServiceAreas()).then(function () {
                    that.displayServiceArea(location);

                    google.maps.event.addListener(infowindow, 'closeclick', function () {
                        marker.setIcon(iconimage);
                        that.closeServiceAreas();
                    });
                    infowindow.open(map, marker);
                });
            });


            marker.addListener('mouseover', function () {
                marker.setIcon(iconimageHover);
            });
            marker.addListener('mouseout', function () {
                marker.setIcon(iconimage);
            });

            markers[location.id] = [];
            markers[location.id].push(marker);
        }

        if (that.settings.selectedLocation.id && that.settings.selectedLocation.id == location.id) {
            marker.setIcon(iconimageHover);
            $.when(that.closeInfoWindows(), that.closeServiceAreas()).then(function () {
                that.displayServiceArea(location);
                infowindow.open(map, marker);
            });
        }


    };


    return this.initialize();

};


$.showOverlay = function ($el = 'body') {

    $($el).find('.overlay-processing').css('z-index', 100).animate({'opacity': 1}, 500);

}
$.removeOverlay = function ($el = 'body') {

    $($el).find('.overlay-processing').removeClass('initial-show');
    $($el).find('.overlay-processing').css('z-index', -1).animate({'opacity': 0}, 500);

}


$.multiArrayReturn = function (arr, search_obj_key_name, search_obj_key_val, return_type, search_obj_key_int, return_arr) {
    var result = false;
    var result_arr = [];
    $.each(arr, function (i, k) {
        if (typeof return_arr != 'undefined' && typeof k[search_obj_key_name] != 'undefined') {
            if (typeof search_obj_key_int != 'undefined' && $.inArray(parseInt(k[search_obj_key_name]), search_obj_key_val) > -1)
                result_arr.push(k);
            else if ($.inArray(k[search_obj_key_name], search_obj_key_val) > -1)
                result_arr.push(k);
        } else if (typeof k[search_obj_key_name] != 'undefined') {
            if (typeof search_obj_key_int != 'undefined' && parseInt(k[search_obj_key_name]) == search_obj_key_val) {
                result = arr[i];
                // result_arr[i] = arr[i];
                result_arr.push(arr[i]);
            } else if (k[search_obj_key_name] == search_obj_key_val) {
                result = arr[i];
                // result_arr[i] = arr[i];
                result_arr.push(arr[i]);
            }
        }
    });

    if (typeof return_arr != 'undefined')
        return result_arr;
    else {
        // Return type defines should i return all results or just one result
        if (return_type)
            return result_arr;
        else
            return result;
    }
}


$.initColorBox = function ($el = '.colorbox', relName = 'sliderName') {

    $($el).colorbox({rel: relName, maxWidth: '98%', maxHeight: '100%'});

    $(document).bind('cbox_complete', function () {
        $('#cboxNext').html('<i class="fas fa-arrow-right"></i>');
        $('#cboxPrevious').html('<i class="fas fa-arrow-left"></i>');
        $('#cboxClose').html('<i class="fas fa-times"></i>');
    });

    $($el).closest('.all-photos').on('click', '#allPhotosClick', function (e) {
        e.preventDefault();
        if ($($el).find('.initCall').length > 0)
            $($el + ' .initCall').click();
        else
            $($el + '.scholl-init-0').click();

        return false;
    })

    $($el).closest('.big-photo').on('click', '#coverClick', function (e) {
        e.preventDefault();
        $($el + '.scholl-init-0').click();
        return false;
    })

    $($el).closest('#selected-school-photos').on('click', '.coverClick', function (e) {
        e.preventDefault();
        var dataImageNumber = $(this).data('image');
        $($el + '.scholl-init-'+dataImageNumber).click();
        return false;
    })
}

$.initProgramsSchool = function ($el = '#school-programs') {
    // $($el).on('click','a.nav-link', function (e) {
    //   e.preventDefault();
    //   // First Hide all other tabs and remove link class
    //   $($el).find('.tab-pane').removeClass('show').removeClass('active');
    //   $($el).find('a.nav-link').removeClass('active');

    //   var idShow = $(this).attr('href');

    //   $($el).find(idShow).tab('show');
    //   $(this).addClass('active');

    //   return false;
    // })
}

$.initLocationListSchool = function ($el = '#small-location-list') {
    // $($el).on('click','a.nav-link', function (e) {
    //   e.preventDefault();
    //   // First Hide all other tabs and remove link class
    //   $($el).find('.tab-pane').removeClass('show').removeClass('active');
    //   $($el).find('a.nav-link').removeClass('active');

    //   var idShow = $(this).attr('href');

    //   $($el).find(idShow).tab('show');
    //   $(this).addClass('active');

    //   return false;
    // })
}

$.initNavigateClick = function ($el = '#location-map') {
    $($el).on('click', 'a.getDirectionClick', function (e) {
        e.preventDefault();
        var lat = $(this).data('lat');
        var lng = $(this).data('lng');

        if (lat && lng) {
            $.navigate(lat, lng);
        }

        return false;
    })
}

$.programReadMoreClick = function ($el = '#school-programs-holder') {
    $($el).on('click', 'a.view-more-button', function (e) {
        e.preventDefault();
        var descriptionHolder = $(this).closest('.program-explanation');

        $(this).hide();
        $(descriptionHolder).find('.program-teaser').hide();
        $(descriptionHolder).find('.program-full-description').show();


        return false;
    })
}

$(document).ready(function () {
    $('#review-display-holder')
        .on('click', 'a.review-view-more-button', function (e) {
            e.preventDefault();
            var parentDiv = $(this).closest('.review-left');

            $(parentDiv).find('.review-teaser').addClass('d-none');
            $(parentDiv).find('.review-full-description').removeClass('d-none');

            return false;
        })
        .on('click', 'a.review-view-less-button', function (e) {
            e.preventDefault();
            var parentDiv = $(this).closest('.review-left');

            $(parentDiv).find('.review-teaser').addClass('d-none');
            $(parentDiv).find('.teaser-less').removeClass('d-none');

            return false;
        })
})

$.navigate = function (lat, lng) {

    if ((navigator.platform.indexOf("iPhone") !== -1) || (navigator.platform.indexOf("iPod") !== -1)) {
        function iOSversion() {
            if (/iP(hone|od|ad)/.test(navigator.platform)) {
                // supports iOS 2.0 and later
                var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
                return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
            }
        }

        var ver = iOSversion() || [0];

        var protocol = 'http://';
        if (ver[0] >= 6) {
            protocol = 'maps://';
        }
        window.location = protocol + 'maps.apple.com/maps?daddr=' + lat + ',' + lng + '&amp;ll=';
    } else {
        window.open('http://maps.google.com?daddr=' + lat + ',' + lng + '&amp;ll=');
    }
}


$.showPopUpWidget = function ($el = '#lw-widget-holder') {
    var urlToCall = $($el).data('url');
    if (!urlToCall)
        var urlToCall = '/schools-per-location';
    setTimeout(function () {
        $.ajax({
            async: true,
            method: "post",
            url: urlToCall,
            success: function (data) {
                $(data).appendTo($($el)).promise().done(function () {
                    if ($('#homepage-populate').length > 0) {
                        $.populateZip();
                    }
                    setTimeout(function () {
                        $.showWidget();
                    }, 1200);
                });
            },
            error: function (data) {
                $.removeOverlay($el);
                // window.location.reload(true);
            }
        });
    }, 2000);
}

$.populateZip = function ($el = '#lw-widget-holder .lw-widget') {
    var zipCode = $($el).find('#zip-populate').val(),
        location = $($el).find('#location-populate').val(),
        lat = $($el).find('#lat-populate').val(),
        lng = $($el).find('#lng-populate').val(),
        city = $($el).find('#city-populate').val();

    if (zipCode && location) {
        $('#homepage-populate').find('#location-zip-filter').val(location);
        $('#homepage-populate').find('#location-zip-city-hidden').val(city);
        $('#homepage-populate').find('#location-zip-filter-hidden').val(zipCode);
        $('#homepage-populate').find('#location-zip-lat-hidden').val(lat);
        $('#homepage-populate').find('#location-zip-lng-hidden').val(lng);
    }
}

$.showWidget = function ($el = '#lw-widget-holder .lw-widget') {
    var widget = document.querySelector($el);
    var overlay = widget.querySelector('.lw-overlay'),
        items = widget.querySelectorAll('.lw-item');

    widget.classList.add('lw-open');
    setTimeout(function () {
        widget.classList.add('lw-animate');
    }, 10);

    items.forEach(function (item) {
        item.classList.add('lw-animate');
        setTimeout(function () {
            item.classList.remove('lw-animate');
            item.classList.add('lw-visible');
            if (!item.dataset.height) {
                item.dataset.height = window.getComputedStyle(item).height;
            }
            if (!item.dataset.marginTop) {
                item.dataset.marginTop = window.getComputedStyle(item).marginTop;
            }
        }, 400);
    });

    $($el).on('click', '.lw-close', function (e) {
        e.preventDefault();
        var urlPost = $(this).attr('href');
        items.forEach(function (item) {
            item.classList.remove('lw-visible');
            item.classList.add('lw-animate-reverse');
            setTimeout(function () {
                item.classList.remove('lw-animate-reverse');
                setTimeout(function () {
                    widget.classList.remove('lw-animate');
                    setTimeout(function () {
                        widget.classList.remove('lw-open');
                        openFlag = true;
                        items.forEach(function (item) {
                            item.animate([{height: 0, marginTop: 0}, {
                                height: item.dataset.height,
                                marginTop: item.dataset.marginTop
                            }], {
                                duration: 0,
                                fill: 'forwards'
                            });
                            setTimeout(function () {
                                item.classList.remove('lw-animated');
                                delete item.dataset.height;
                                delete item.dataset.marginTop;
                            }, 10);
                        });
                    }, 400);
                }, 400);

            }, 400);
        });

        return false;
    });
};


$.initLoadEmailsSchool = function ($el = '#load-emails-click') {
    $($el).on('click', 'a#load-emails', function (e) {
        e.preventDefault();
        var urlPost = $(this).attr('data-href');
        if (urlPost) {
            $.ajax({
                method: "post",
                url: urlPost,
                success: function (data) {
                    if (data) {
                        $(data).insertAfter($($el)).promise().done(function () {
                            $($el).hide(200);
                        });

                    }


                },
                error: function (data) {
                    $.removeOverlay($el);
                    // window.location.reload(true);
                }
            });
        }

        return false;
    });
}

$.initReviewForm = function ($el = '#review-form') {
    $($el).on('click', function () {
        var reviewForm = $(this).closest('#selected-school-reviews').find('#add-review-field');

        if ($(reviewForm).length > 0) {
            if ($(reviewForm).hasClass('init-hidden')) {
                $(reviewForm).removeClass('init-hidden').slideDown(400);
                $(this).html('<i class="fas fa-times"></i>Cancel review writing');

            } else {
                $(reviewForm).addClass('init-hidden').slideUp(400);
                $(this).html('<i class="fas fa-pencil-alt"></i>Write a review');
            }
        }

        return false;
    });


    $($el).closest('#selected-school-reviews').on('click', 'a#loadMoreRevies', function () {

        var link = $(this);
        var schoolSlug = $(this).data('school');
        var reviewsHolder = $($el).closest('#selected-school-reviews').find('#review-display-holder');

        $.ajax({
            method: "get",
            url: "/reviews/" + schoolSlug,
            success: function (data) {
                if (data) {
                    $(reviewsHolder).html(data);
                    $(link).closest('.load-more').remove();

                }
            },
            error: function (data) {

                // window.location.reload(true);
            }
        });
        return false;

    });
}
$.smoothScroll = function ($el = 'body') {


    $($el).find('a.scroller-link')
        .not('[href="#"]')
        .not('[href="#0"]')
        .on('click', function (event) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {

                var target = $(this.hash);
                var speed = ($(this).data('speed')) ? parseInt($(this).data('speed')) : 1000;
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                $(this).closest('ul').find('.active').removeClass('active');

                if (target.length) {
                    event.preventDefault();
                    if ($el == 'body')
                        var scrollElement = 'html, body';
                    else
                        var scrollElement = $el;

                    $(this).closest('li').addClass('active');

                    $(scrollElement).animate({
                        scrollTop: target.offset().top - 40
                    }, speed, function () {


                        var $target = $(target);
                        $target.focus();
                        // if ($target.is(":focus")) {
                        //   return false;
                        // } else {
                        //   $target.attr('tabindex','-1');
                        //   $target.focus();
                        // };
                    });
                }
            }
        });

}

// Search by ALL
$.filter_sitemap_search = function (value, $el = 'body') {

    var searchBy = {'q': value};

    $.showOverlay($el)
    $.ajax({
        async: true,
        method: "post",
        url: "/search",
        data: searchBy,
        success: function (data) {
            if (data) {
                $($el).html(data);
            }
            $.removeOverlay($el);


        },
        error: function (data) {
            $.removeOverlay($el);
            // window.location.reload(true);
        }
    });


}

// Search by Zip or City
$.filter_zipLocation_search = function (value, $el = 'body') {

    var searchBy = {'q': value};

    $.showOverlay($el)
    $.ajax({
        async: true,
        method: "post",
        url: "/zip/filter",
        data: searchBy,
        success: function (data) {
            if (data) {
                $($el).html(data);
            }
            $.removeOverlay($el);

            setTimeout(function () {
                var countOurResults = $($el).find('li.filter:not(.disabled)').length;
                if (typeof gtag === 'function') {
                    var labelVal = value + ' -> ' + countOurResults;

                    // gtag('event', 'search', {
                    //   'event_category' : 'industry_search_results',
                    //   'event_label' : labelVal
                    // });
                }
            }, 100);

        },
        error: function (data) {
            $.removeOverlay($el);
            // window.location.reload(true);
        }
    });


}


// Load School List
function load_school_list(mapPosition = '', $el = 'body') {

    if (!mapPosition)
        mapPosition = {};

    $.showOverlay($el)
    $.ajax({
        async: true,
        method: "post",
        url: "/location/list",
        data: mapPosition,
        success: function (data) {
            if (data) {
                $($el).html(data);
            }
            $.removeOverlay($el);

            setTimeout(function () {
                var countOurResults = $($el).find('li.filter:not(.disabled)').length;
                if (typeof gtag === 'function') {
                    var labelVal = value + ' -> ' + countOurResults;

                    // gtag('event', 'search', {
                    //   'event_category' : 'industry_search_results',
                    //   'event_label' : labelVal
                    // });
                }
            }, 100);

        },
        error: function (data) {
            $.removeOverlay($el);
            // window.location.reload(true);
        }
    });


}


function load_map(mapWrapper, query = '', $schoolListEl = '') {

    if (typeof styledMapType === 'undefined' || !styledMapType)
        var styledMapType = $.getStyledGoogleMap();

    if ($('#' + mapWrapper).length > 0) {
        var geocoder = new google.maps.Geocoder();

        if (query && query.lat && query.lng)
            centerMap = {lat: parseFloat(query.lat), lng: parseFloat(query.lng)};
        else
            centerMap = {lat: 39.381266, lng: -97.922211};

        // geocoder.geocode({'address': query}, function(results, status) {
        //   if (status === 'OK') {
        map = new google.maps.Map(document.getElementById(mapWrapper), {
            zoom: 10,
            center: centerMap,
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeControl: false,
            mapTypeControlOptions: {
                mapTypeIds: ['styled_map']
            }
        });

        mapLoaded = true;
        // map.setCenter(results[0].geometry.location);
        map.mapTypes.set('styled_map', styledMapType);
        map.setMapTypeId('styled_map');

        if ($schoolListEl)
            load_school_list(query, $schoolListEl);

        // if(postSearch.mapPointers && postSearch.mapPointers.lat && postSearch.mapPointers.lng && postSearch.mapPointers.radius){
        //     map.setCenter({lat: parseFloat(postSearch.mapPointers.lat), lng: parseFloat(postSearch.mapPointers.lng)});
        //     addMarker({lat: parseFloat(postSearch.mapPointers.lat), lng: parseFloat(postSearch.mapPointers.lng)}, map);
        // }
        // addMarker(results[0].geometry.location, map,mapWrapper);
        //  google.maps.event.addListener(map, 'click', function(event) {
        //   addMarker(event.latLng, map, mapWrapper);
        // });


        //   } else {
        //     alert('Geocode was not successful for the following reason: ' + status);
        //   }
        // });
    } else {
        alert('Geocode was not successful for the following reason: Missing Map Holder');
    }
}


// Adds a marker to the map.
function addMarker(location, map, mapWrapper) {
    setMapOnAll(mapWrapper);
    // Add the marker at the clicked location, and add the next-available label
    // from the array of alphabetical characters.
    // var iconimage = new google.maps.MarkerImage("../img/map-pointer2.png", null, null, null, new google.maps.Size(20,32));

    var marker = new google.maps.Marker({
        position: location,
        label: '',
        // icon: iconimage,
        draggable: true,
        map: map,
        animation: google.maps.Animation.DROP,
    });

    markers[mapWrapper] = [];
    markers[mapWrapper].push(marker);


    if ($('#' + mapWrapper).closest('form').find('input[name="longitude"]').length > 0) {
        $('#' + mapWrapper).closest('form').find('input[name="longitude"]').val(marker.getPosition().lng().toFixed(8));
    }
    if ($('#' + mapWrapper).closest('form').find('input[name="latitude"]').length > 0) {
        $('#' + mapWrapper).closest('form').find('input[name="latitude"]').val(marker.getPosition().lat().toFixed(8));
    }


}

// Sets the map on all markers in the array.
function setMapOnAll(map) {
    if (markers[map] && markers[map].length > 0) {
        for (var i = 0; i < markers[map].length; i++) {
            markers[map][i].setMap(null);
            // circles[i].setMap(map);
        }
    }

}


$.append_notification = function (status, text_content) {


    var randomString = 'notification_' + Math.random().toString(36).substring(7);
    var notification_html = '<div class="border2 closable ' + status + ' notification slide_notification ' + randomString + '">' +
        '<a class="close_toast" href="javascript:;"><span class="fas fa-times"></span></a>' +
        '<p>' + text_content + '</p>' +
        '</div>';

    jQuery('#notification_content').prepend(notification_html);

    setTimeout(function () {
        jQuery('div.' + randomString).removeClass('slide_notification');
    }, 250);

    //trigger the automatic slideUp;
    $.hide_notification(jQuery('div.' + randomString));
}


$.hide_notification = function ($div, click) {
    click = (click) ? true : false;

    if (click) {
        trigger_hide_notification();
    } else {
        setTimeout(function () {
            trigger_hide_notification();
        }, 7000);
    }

    function trigger_hide_notification() {
        $div.addClass('slide_notification');
        setTimeout(function () {
            $div.remove();
        }, 300);
    }
}


$.getStyledGoogleMap = function () {
    return new google.maps.StyledMapType(
        [
            {
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "administrative.country",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "lightness": 5
                    },
                    {
                        "weight": 1.5
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#bdbdbd"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#edf0f5"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dadada"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#c9c9c9"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#d5dae2"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            }
        ],
        {name: 'Styled Map'});


}

if (window.DrivingSchools && typeof window.DrivingSchools.markAssetsReady === 'function') {
    window.DrivingSchools.markAssetsReady();
}
